import { getLayer } from '../layerService.js';

export default class ObjectMoveCommand {
    constructor({ description, objectUuid, prevX, prevY, finalX, finalY, pageUuid }) {
        this.id = crypto.randomUUID();
        this.timestamp = Date.now();
        this.description = description ?? 'Move';
        this.category = 'layout';
        this.objectUuid = objectUuid;
        this.affectedUuids = [objectUuid];
        this.pageUuid = pageUuid ?? null;
        this.prevX = prevX;
        this.prevY = prevY;
        this.finalX = finalX;
        this.finalY = finalY;
    }

    _applyPosition(x, y) {
        const layer = getLayer();
        if (!layer) return;
        const node = layer.findOne('#' + this.objectUuid);
        if (!node) return;
        node.x(x);
        node.y(y);
        node.getLayer()?.batchDraw();
    }

    execute() {
        this._applyPosition(this.finalX, this.finalY);
    }

    undo() {
        this._applyPosition(this.prevX, this.prevY);
    }

    canMergeWith(other) {
        return (
            other instanceof ObjectMoveCommand &&
            other.objectUuid === this.objectUuid &&
            other.timestamp - this.timestamp < 500
        );
    }

    mergeWith(other) {
        this.finalX = other.finalX;
        this.finalY = other.finalY;
        this.timestamp = other.timestamp;
    }

    toJSON() {
        return {
            type: 'ObjectMove',
            id: this.id,
            timestamp: this.timestamp,
            payload: {
                objectUuid: this.objectUuid,
                prevX: this.prevX,
                prevY: this.prevY,
                finalX: this.finalX,
                finalY: this.finalY,
            },
        };
    }
}
